import { NextQuery } from '@empathy/search-types';
import { GridItem, NextQueriesConfig, ResultsGridConfig } from '../../../../models';
import { GETTERS_KEYS } from '../../../store.const';
import { RootStoreState } from '../../../store.interfaces';
import { SearchGetterContext } from '../../search.interfaces';
import { GridItemsReducer } from './grid-items-reducer.interfaces';

export class NextQueriesReducer implements GridItemsReducer {
  private nextQueriesToInsert: NextQuery[];

  reduce(gridItems: GridItem[], { state, rootGetters, rootState }: SearchGetterContext): GridItem[] {
    const {
      pageFrequency,
      perLoad,
      max,
      maxWhenNotReachingTrigger,
      withResults
    }: NextQueriesConfig = rootGetters[GETTERS_KEYS.config.config].nextQueries;
    const resultGrid: ResultsGridConfig = rootGetters[GETTERS_KEYS.config.config].resultsGrid;
    const hasMoreResults = rootGetters[GETTERS_KEYS.search.hasMoreResults];
    const nextQueries = this.getNextQueries(withResults, rootGetters, rootState);

    this.nextQueriesToInsert = [];
    nextQueries.some((nextQuery, nextQueryIndex) => {
      const indexOffset = Math.trunc(nextQueryIndex / perLoad);
      const insertionPage = (indexOffset + 1) * pageFrequency;
      const nextQueryInsertionIndex = insertionPage * resultGrid.pageSize + state.banners.length;

      if (nextQueryIndex >= max
        || (nextQueryInsertionIndex >= gridItems.length && hasMoreResults)
        || (nextQueryIndex >= maxWhenNotReachingTrigger && !hasMoreResults)
      ) {
        // We break the loop if there is a limit of next queries to show, if the insertion index isn't reached yet and there are
        // still more results or if the maxWhenNotReachingTrigger is exceeded and there aren't more results
        return true;
      }

      this.nextQueriesToInsert.push(nextQuery);
      if (this.nextQueriesToInsert.length === perLoad || (nextQueryIndex + 1) === nextQueries.length) {
        // Insert Next Queries if length is 'perLoad' value or total of Next Queries is not multiple of 'perLoad' (the rest of NQs)
        this.insertNextQueries(gridItems, (nextQueryInsertionIndex + indexOffset));
        this.nextQueriesToInsert = [];
      }
    });

    return gridItems;
  }

  private getNextQueries(withResults: boolean, rootGetters: any, rootState: RootStoreState): NextQuery[] {
    return withResults
      ? rootGetters[GETTERS_KEYS.querySignals.nextQueriesWithResults]
      : rootState.querySignals.nextQueries;
  }

  private insertNextQueries(gridItems: GridItem[], indexToInsert: number) {
    gridItems.splice(indexToInsert, 0, {
      modelName: 'NextQueries',
      id: this.generateId(),
      nextQueries: this.nextQueriesToInsert
    });
  }

  private generateId(): string {
    return this.nextQueriesToInsert.reduce((idAccumulator, { id }) => idAccumulator + id, '');
  }
}
